export type TranslatedSlug = {
	lang?: string | null;
	path?: string | null;
	name?: string | null;
	id?: number | null;
};

export const fixStoryblokLanguage = (language: string): string => {
	return language === "en-US" ? "default" : language;
};

export const findTranslatedSlugId = (
	language: string,
	page?: {
		translated_slugs?: readonly (TranslatedSlug | null)[] | null;
	} | null,
): number | undefined =>
	page?.translated_slugs?.find((slug) => hasSiteLanguage(language, slug))?.id ??
	undefined;

export const findTranslatedSlugName = (
	language: string,
	page?: {
		translated_slugs?: readonly (TranslatedSlug | null)[] | null;
		name?: string | null;
	} | null,
): string => {
	if (typeof page?.name !== "string") throw new Error("Name is undefined");

	if (language === "default") {
		return page.name;
	} else {
		const slug = page.translated_slugs?.find((slug) =>
			hasSiteLanguage(language, slug),
		);
		return slug?.name ?? page.name;
	}
};

export const findTranslatedSlugPath = (
	language: string,
	page?: {
		translated_slugs?: readonly (TranslatedSlug | null)[] | null;
		default_full_slug?: string | null;
	} | null,
): string => {
	if (typeof page?.default_full_slug !== "string")
		throw new Error("Default full slug is undefined");

	if (language === "default") {
		return page.default_full_slug;
	} else {
		const slug = page.translated_slugs?.find((slug) =>
			hasSiteLanguage(language, slug),
		);
		return slug?.path ?? page.default_full_slug;
	}
};

export const findTranslatedSlugNameFromLink = (
	language: string,
	page?: {
		alternates?: readonly (TranslatedSlug | null)[] | null;
		name?: string | null;
	} | null,
): string => {
	if (typeof page?.name !== "string") throw new Error("Name is undefined");

	if (language === "default") {
		return page.name;
	} else {
		const slug = page.alternates?.find((slug) =>
			hasSiteLanguage(language, slug),
		);
		return slug?.name ?? page.name;
	}
};

export const findTranslatedSlugPathFromLink = (
	language: string,
	page?: {
		alternates?: readonly (TranslatedSlug | null)[] | null;
		real_path?: string | null;
	} | null,
): string => {
	if (typeof page?.real_path !== "string")
		throw new Error("Real path is undefined");

	if (language === "default") {
		return page.real_path;
	} else {
		const slug = page.alternates?.find((slug) =>
			hasSiteLanguage(language, slug),
		);
		return slug?.path ?? page.real_path;
	}
};

const hasSiteLanguage = (
	language: string,
	object: TranslatedSlug | null,
): boolean => object?.lang === language;
